import { render, staticRenderFns } from "./AsignacionDocumentosForm.vue?vue&type=template&id=c409771a"
import script from "./AsignacionDocumentosForm.vue?vue&type=script&lang=js"
export * from "./AsignacionDocumentosForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports